(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .component('journeyMap', {
            bindings: {
                activePointKey: '<?',
                geometry: '<',
                points: '<',
                height: '@',
                refreshToken: '<?',
                fitBoundsToken: '<?',
                showRoute: '<?'
            },
            templateUrl: 'app/components/journey-map/journey-map.tpl.html',
            controller: JourneyMapController
        });

    JourneyMapController.$inject = ['$scope', '$timeout', 'leafletData'];

    function JourneyMapController($scope, $timeout, leafletData) {
        var ctrl = this;

        var defaultCenter = {
            lat: 0,
            lng: 0,
            zoom: 2
        };

        ctrl.mapId = 'journey_map_' + Math.floor(Math.random() * 1000000000);
        ctrl.refreshVersion = 0;
        ctrl.lastFocusedPointKey = null;
        ctrl.ignoreActivePointOnce = false;

        angular.extend($scope, {
            bounds: null,
            center: angular.copy(defaultCenter),
            defaults: {
                scrollWheelZoom: false
            },
            renderMap: true,
            layers: {
                baselayers: {
                    osm: {
                        name: 'OpenStreetMap',
                        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        type: 'xyz'
                    },
                    satelite: {
                        name: 'Satelite',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                        type: 'xyz'
                    }
                }
            },
            markers: {},
            paths: {}
        });

   /*     ctrl.$onInit = function() {
            $scope.$watch(function() {
                return ctrl.activePointKey;
            }, function(newValue, oldValue) {
                if (!newValue) {
                    return;
                }

                if (newValue === oldValue && newValue === ctrl.lastFocusedPointKey) {
                    return;
                }

                ctrl.lastFocusedPointKey = newValue;
                focusActivePointOnly();
            });
        };

		ctrl.$onChanges = function(changesObj) {
		    if (changesObj.fitBoundsToken) {
		        refreshMap(true);
		        return;
		    }

		    if (changesObj.points || changesObj.geometry || changesObj.showRoute || changesObj.refreshToken) {
		        refreshMap(false);
		    }
		};
*/
ctrl.$onInit = function() {
    console.error('JOURNEY MAP INIT', ctrl.mapId);

    $scope.$watchGroup([
        function() { return ctrl.points; },
        function() { return ctrl.geometry; },
        function() { return ctrl.refreshToken; },
        function() { return ctrl.fitBoundsToken; },
        function() { return ctrl.showRoute; }
    ], function(newValues, oldValues) {
        if (!oldValues) {
            return;
        }

        console.error('JOURNEY MAP WATCH GROUP', {
            refreshToken: newValues[2],
            fitBoundsToken: newValues[3]
        });

        var fitBoundsChanged = newValues[3] !== oldValues[3];
        refreshMap(fitBoundsChanged);
    });

    $scope.$watch(function() {
        return ctrl.activePointKey;
    }, function(newValue, oldValue) {
        if (!newValue) {
            return;
        }

        if (newValue === oldValue && newValue === ctrl.lastFocusedPointKey) {
            return;
        }

        ctrl.lastFocusedPointKey = newValue;
        focusActivePointOnly();
    });
};

        ctrl.zoomToData = function() {
            ctrl.ignoreActivePointOnce = true;
            refreshMap(true);
        };

        function refreshMap(forceFitBounds) {
            ctrl.refreshVersion += 1;
            var refreshVersion = ctrl.refreshVersion;

            var points = angular.isArray(ctrl.points) ? ctrl.points : [];
            var geometryPaths = buildGeometryPaths(ctrl.geometry);
            var validPoints = points.filter(function(point) {
                return isFiniteNumber(point.lat) && isFiniteNumber(point.lon);
            });
            var shouldShowRoute = ctrl.showRoute !== false;

            if (!validPoints.length && !geometryPaths.length) {
                applyMapState({}, {}, angular.copy(defaultCenter), null, null, false, refreshVersion);
                ctrl.ignoreActivePointOnce = false;
                return;
            }

            var markers = {};
            var pathMap = {};
            var routeLatLngs = [];
            var minLat = Number.POSITIVE_INFINITY;
            var maxLat = Number.NEGATIVE_INFINITY;
            var minLon = Number.POSITIVE_INFINITY;
            var maxLon = Number.NEGATIVE_INFINITY;
            var activePoint = null;

            angular.forEach(validPoints, function(point, index) {
                var markerKey = normalizeMarkerKey(point.key || ('point' + index));
                var isActive = !ctrl.ignoreActivePointOnce && normalizeMarkerKey(ctrl.activePointKey) === markerKey;

                markers[markerKey] = {
                    lat: point.lat,
                    lng: point.lon,
                    focus: isActive,
                    icon: buildMarkerIcon(point),
                    message: buildMessage(point),
                    draggable: false
                };

                if (isActive) {
                    activePoint = point;
                }

                routeLatLngs.push({
                    lat: point.lat,
                    lng: point.lon
                });

                updateExtrema(point.lat, point.lon);
            });

            if (shouldShowRoute && validPoints.length > 1) {
                pathMap.route = {
                    color: '#1f77b4',
                    weight: 4,
                    latlngs: routeLatLngs,
                    opacity: 0.75
                };
            }

            angular.forEach(geometryPaths, function(path, index) {
                pathMap['area' + index] = path;
                angular.forEach(path.latlngs, function(latlng) {
                    updateExtrema(latlng.lat, latlng.lng);
                });
            });

            if (activePoint) {
                applyMapState(markers, pathMap, {
                    lat: activePoint.lat,
                    lng: activePoint.lon,
                    zoom: activePoint.focusZoom || 17
                }, null, activePoint, false, refreshVersion);
                ctrl.ignoreActivePointOnce = false;
                return;
            }

            if (!geometryPaths.length && validPoints.length === 1) {
                applyMapState(markers, pathMap, {
                    lat: validPoints[0].lat,
                    lng: validPoints[0].lon,
                    zoom: validPoints[0].focusZoom || 16
                }, null, null, false, refreshVersion);
                ctrl.ignoreActivePointOnce = false;
                return;
            }

            var bounds = buildBounds(minLat, maxLat, minLon, maxLon);

            applyMapState(
                markers,
                pathMap,
                {
                    lat: minLat + ((maxLat - minLat) / 2),
                    lng: minLon + ((maxLon - minLon) / 2),
                    zoom: 5
                },
                bounds,
                null,
                !!forceFitBounds,
                refreshVersion
            );

            ctrl.ignoreActivePointOnce = false;

            function updateExtrema(lat, lon) {
                minLat = Math.min(minLat, lat);
                maxLat = Math.max(maxLat, lat);
                minLon = Math.min(minLon, lon);
                maxLon = Math.max(maxLon, lon);
            }
        }

        function focusActivePointOnly() {
            var points = angular.isArray(ctrl.points) ? ctrl.points : [];
            var targetKey = normalizeMarkerKey(ctrl.activePointKey);
            var activePoint = null;
            var refreshVersion = ctrl.refreshVersion;

            angular.forEach(points, function(point, index) {
                var markerKey = normalizeMarkerKey(point.key || ('point' + index));
                if (markerKey === targetKey) {
                    activePoint = point;
                }
            });

            if (!activePoint) {
                return;
            }

            focusMarker(activePoint, 0, refreshVersion);
        }

        function applyMapState(markers, paths, center, bounds, activePoint, forceFitBounds, refreshVersion) {
            $scope.renderMap = false;

            $timeout(function() {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }

                $scope.markers = markers;
                $scope.paths = paths;
                $scope.center = center;
                $scope.bounds = bounds;
                $scope.renderMap = true;

                $timeout(function() {
                    if (refreshVersion !== ctrl.refreshVersion) {
                        return;
                    }

                    if (forceFitBounds && bounds) {
                        fitMapToBounds(bounds, 0, refreshVersion);
                        return;
                    }

                    if (activePoint) {
                        focusMarker(activePoint, 0, refreshVersion);
                    }
                }, 0);
            }, 0);
        }

        function focusMarker(activePoint, attempt, refreshVersion) {
            attempt = attempt || 0;

            if (refreshVersion !== ctrl.refreshVersion) {
                return;
            }

            leafletData.getMap(ctrl.mapId).then(function(map) {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }

                if (!map) {
                    retryFocus(activePoint, attempt, refreshVersion);
                    return;
                }

                map.setView([activePoint.lat, activePoint.lon], activePoint.focusZoom || 17, {
                    animate: true
                });

                $timeout(function() {
                    if (refreshVersion !== ctrl.refreshVersion) {
                        return;
                    }
                    openPopupForPoint(map, activePoint, attempt, refreshVersion);
                }, 250);
            });
        }

        function openPopupForPoint(map, activePoint, attempt, refreshVersion) {
            if (refreshVersion !== ctrl.refreshVersion) {
                return;
            }

            var popupOpened = false;

            angular.forEach(map._layers, function(layer) {
                if (popupOpened || !layer || !layer.getLatLng || !layer.openPopup) {
                    return;
                }

                var latLng = layer.getLatLng();
                if (!latLng) {
                    return;
                }

                var sameLat = Math.abs(latLng.lat - activePoint.lat) < 0.000001;
                var sameLng = Math.abs(latLng.lng - activePoint.lon) < 0.000001;

                if (sameLat && sameLng) {
                    if (layer.getPopup && !layer.getPopup()) {
                        return;
                    }

                    layer.openPopup();
                    popupOpened = true;
                }
            });

            if (!popupOpened) {
                retryFocus(activePoint, attempt, refreshVersion);
            }
        }

        function retryFocus(activePoint, attempt, refreshVersion) {
            if (attempt >= 6) {
                return;
            }

            $timeout(function() {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }
                focusMarker(activePoint, attempt + 1, refreshVersion);
            }, 180);
        }

        function fitMapToBounds(bounds, attempt, refreshVersion) {
            attempt = attempt || 0;

            if (refreshVersion !== ctrl.refreshVersion) {
                return;
            }

            leafletData.getMap(ctrl.mapId).then(function(map) {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }

                if (!map) {
                    retryFitBounds(bounds, attempt, refreshVersion);
                    return;
                }

                map.fitBounds([
                    [bounds.southWest.lat, bounds.southWest.lng],
                    [bounds.northEast.lat, bounds.northEast.lng]
                ], {
                    animate: false,
                    padding: [20, 20]
                });
            });
        }

        function retryFitBounds(bounds, attempt, refreshVersion) {
            if (attempt >= 5) {
                return;
            }

            $timeout(function() {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }
                fitMapToBounds(bounds, attempt + 1, refreshVersion);
            }, 120);
        }

        function buildBounds(minLat, maxLat, minLon, maxLon) {
            var latSpan = maxLat - minLat;
            var lonSpan = maxLon - minLon;

            var latPadding = Math.max(latSpan * 0.12, 0.0015);
            var lonPadding = Math.max(lonSpan * 0.12, 0.0015);

            return {
                northEast: {
                    lat: maxLat + latPadding,
                    lng: maxLon + lonPadding
                },
                southWest: {
                    lat: minLat - latPadding,
                    lng: minLon - lonPadding
                }
            };
        }

        function buildGeometryPaths(geometry) {
            var polygons = extractPolygons(geometry);
            var paths = [];

            angular.forEach(polygons, function(polygon) {
                angular.forEach(polygon, function(ring, ringIndex) {
                    var latlngs = [];

                    angular.forEach(ring, function(coord) {
                        if (!angular.isArray(coord) || coord.length < 2) {
                            return;
                        }

                        var lon = parseCoordinate(coord[0]);
                        var lat = parseCoordinate(coord[1]);

                        if (lat === null || lon === null) {
                            return;
                        }

                        latlngs.push({
                            lat: lat,
                            lng: lon
                        });
                    });

                    if (latlngs.length >= 3) {
                        paths.push({
                            type: 'polygon',
                            color: ringIndex === 0 ? '#2c7a3f' : '#4a5568',
                            weight: ringIndex === 0 ? 3 : 2,
                            fillColor: ringIndex === 0 ? '#8fd19e' : '#cbd5e0',
                            fillOpacity: ringIndex === 0 ? 0.18 : 0.05,
                            latlngs: latlngs,
                            dashArray: ringIndex === 0 ? null : '6 6'
                        });
                    }
                });
            });

            return paths;
        }

        function extractPolygons(geometry) {
            var payload = geometry;

            if (!payload) {
                return [];
            }

            if (angular.isString(payload)) {
                try {
                    payload = angular.fromJson(payload);
                } catch (e) {
                    return [];
                }
            }

            if (payload.geometry) {
                payload = payload.geometry;
            }

            if (!payload || !payload.type || !angular.isArray(payload.coordinates)) {
                return [];
            }

            if (payload.type === 'MultiPolygon') {
                return payload.coordinates;
            }

            if (payload.type === 'Polygon') {
                return [payload.coordinates];
            }

            return [];
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function buildMessage(point) {
            var parts = [];

            if (point.sequence) {
                parts.push('<strong>#' + escapeHtml(String(point.sequence)) + '</strong>');
            }
            if (point.dateLabel) {
                parts.push(escapeHtml(point.dateLabel));
            }
            if (point.title) {
                parts.push(escapeHtml(point.title));
            }
            if (point.subtitle) {
                parts.push(escapeHtml(point.subtitle));
            }
            if (point.valueLabel) {
                parts.push(escapeHtml(point.valueLabel));
            }

            return parts.join('<br/>');
        }

        function buildMarkerIcon(point) {
            if (!point || !point.markerHtml) {
                return undefined;
            }

            return {
                type: 'div',
                className: point.markerClassName || 'journey-map-div-icon',
                html: point.markerHtml,
                iconSize: point.iconSize || [36, 36],
                iconAnchor: point.iconAnchor || [18, 18],
                popupAnchor: point.popupAnchor || [0, -18]
            };
        }

        function normalizeMarkerKey(value) {
            if (value === null || value === undefined || value === '') {
                return 'point';
            }

            return String(value).replace(/[^A-Za-z0-9_]/g, '_');
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function isFiniteNumber(value) {
            return angular.isNumber(value) && !isNaN(value) && isFinite(value);
        }
    }
})();